import { render, staticRenderFns } from "./carbon0.vue?vue&type=template&id=0d0242ba&scoped=true&"
import script from "./carbon0.vue?vue&type=script&lang=js&"
export * from "./carbon0.vue?vue&type=script&lang=js&"
import style0 from "./carbon0.vue?vue&type=style&index=0&id=0d0242ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0242ba",
  null
  
)

export default component.exports